import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import "wxrecall/components/ProductInput.css";

/**
 * Renders an alphanumeric product selector, and optional corresponding dropdown box.
 */
function ProductInput(props) {
  let choicesMenu = null;
  if (props.choices !== undefined) {
    const value =
      props.productState.value || props.productState.value === ""
        ? props.productState.value
        : props.productState.historicalHours;
    const title = props.productState.title || "historical_hours";

    choicesMenu = (
      <select
        value={value}
        onChange={props.onChoiceChange}
        title={props.intl.formatMessage({ id: title })}
        disabled={!props.productState.enabled}
      >
        {props.choices.map(m => (
          <option key={m.label} value={m.value}>
            {props.intl.formatMessage({ id: m.label })}
          </option>
        ))}
      </select>
    );
  }
  return (
    <div className="product-input">
      <label htmlFor={props.product + "-toggle"}>
        <input
          type="checkbox"
          id={props.product + "-toggle"}
          onChange={props.onProductToggle}
          checked={props.productState.enabled}
        />
        <FormattedMessage
          id={props.product.toUpperCase()}
          defaultMessage={props.product.toUpperCase()}
        />
      </label>
      {choicesMenu}
    </div>
  );
}

ProductInput.propTypes = {
  // The string name of the product, used mostly for unique ids and label-input matching (htmlfor)
  product: PropTypes.string.isRequired,
  // Object representing the product data (see DefaultState.js for structure details)
  productState: PropTypes.object.isRequired,
  // A callback fired when the user toggles the checkbox
  onProductToggle: PropTypes.func,
  // An optional array of choice objects. If provided, a dropdown box will be rendered with the given options
  choices: PropTypes.array,
  // A callback fired when a choice changes
  onChoiceChange: PropTypes.func,
  // i18n object
  intl: PropTypes.object
};

export default injectIntl(ProductInput);
